import { ActivityTemplateQueryProvider } from "__legacy/queries/activities/ActivityTemplateQueryProvider";
import { UpdateActivityTemplateMutationProvider } from "__legacy/queries/activities/UpdateActivityTemplateMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { onError, onFinish, TemplateForm } from "./TemplateForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <ActivityTemplateQueryProvider variables={{ id }}>
      {({ activityTemplate }) => (
        <UpdateActivityTemplateMutationProvider
          onError={onError(form, setErrors)}
          onCompleted={() => navigate("../..")}
        >
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit Template ${activityTemplate.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../..")}>Back to list</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <TemplateForm
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={activityTemplate}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateActivityTemplateMutationProvider>
      )}
    </ActivityTemplateQueryProvider>
  );
};
